import * as React from "react";
import { Link } from "react-router-dom";

import { SimpleHorse } from "../../model/Horse";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";
import { SimpleHorseForSale } from "src/model/HorseForSale";

export const HorseForSaleLink = ({
    horseForSale,
    className,
    targetBlank,
    showAsButton
}: {
    horseForSale: SimpleHorseForSale;
    targetBlank?: boolean;
    showAsButton?: boolean;
    className?: string;
    children?: React.ReactNode;
}) => {
    return (
        <Link
            to={`/horses-for-sale/${horseForSale.id}/application`}
            className={`${showAsButton ? "btn btn-info btn-sm" : ""} ${className ? className : "d-block"} `}
            target={targetBlank ? "_blank" : ""}
        >
            #{horseForSale.hipNumber}&nbsp;{horseForSale.horse.name}
            {targetBlank && <FontAwesomeIcon icon={faExternalLinkSquareAlt} className="ml-2 mr-2" />}
        </Link>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/HorseForSaleLink.tsx